/**
 * DLP APi
 * DLP Services
 *
 * OpenAPI spec version: 1.0
 * Contact: check
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { LocalityDetailsDto } from '../model/localityDetailsDto';
import { NdIndPincode } from '../model/ndIndPincode';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class LocalityDetailsControllerService {

    protected basePath = 'https://localhost:8080/nrfsi/nissan';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * clearCache
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clearCacheUsingGET(observe?: 'body', reportProgress?: boolean): Observable<string>;
    public clearCacheUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public clearCacheUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public clearCacheUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<string>(`${this.basePath}/locality/clearCache`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getAddressbyPincode
     * 
     * @param localDto localDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAddressbyPincodeUsingPOST1(localDto: LocalityDetailsDto, observe?: 'body', reportProgress?: boolean): Observable<LocalityDetailsDto>;
    public getAddressbyPincodeUsingPOST1(localDto: LocalityDetailsDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<LocalityDetailsDto>>;
    public getAddressbyPincodeUsingPOST1(localDto: LocalityDetailsDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<LocalityDetailsDto>>;
    public getAddressbyPincodeUsingPOST1(localDto: LocalityDetailsDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (localDto === null || localDto === undefined) {
            throw new Error('Required parameter localDto was null or undefined when calling getAddressbyPincodeUsingPOST1.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<LocalityDetailsDto>(`${this.basePath}/locality/pincode`,
            localDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getPincodeDetails
     * 
     * @param pincode pincode
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPincodeDetailsUsingGET(pincode: string, observe?: 'body', reportProgress?: boolean): Observable<Array<NdIndPincode>>;
    public getPincodeDetailsUsingGET(pincode: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<NdIndPincode>>>;
    public getPincodeDetailsUsingGET(pincode: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<NdIndPincode>>>;
    public getPincodeDetailsUsingGET(pincode: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (pincode === null || pincode === undefined) {
            throw new Error('Required parameter pincode was null or undefined when calling getPincodeDetailsUsingGET.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<NdIndPincode>>(`${this.basePath}/locality/pincode/${encodeURIComponent(String(pincode))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
